import React from 'react'
import { theme } from '@/styles/theme'

interface HomeIconProps extends React.SVGProps<SVGSVGElement> {
  active?: boolean
}

const HomeIcon: React.FC<HomeIconProps> = ({ active, ...props }) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.4355 15.0205C29.4355 14.7601 29.3341 14.5115 29.1553 14.3262L29.0732 14.251L19.5732 6.3789C19.2033 6.07273 18.6678 6.07273 18.2979 6.3789L8.79785 14.251L8.71582 14.3262C8.53697 14.5115 8.43563 14.7601 8.43555 15.0205V28.8506C8.43555 29.3683 8.82889 29.7944 9.33301 29.8457L9.43555 29.8506H28.4355L28.5381 29.8457C29.0086 29.7978 29.3828 29.4236 29.4307 28.9531L29.4355 28.8506V15.0205ZM30.4355 28.8506C30.4355 29.9552 29.5401 30.8506 28.4355 30.8506H9.43555C8.33098 30.8506 7.43555 29.9552 7.43555 28.8506V15.0205C7.43564 14.4251 7.70072 13.8604 8.15918 13.4805L17.6592 5.60937C18.3993 4.99609 19.4718 4.9961 20.2119 5.60937L29.7119 13.4805C30.1704 13.8604 30.4355 14.4251 30.4355 15.0205V28.8506Z"
      fill={active ? theme.palette.primary[400] : theme.palette.gray[400]}
    />
    <path
      d="M27.057 15.2758C27.2962 15.4655 27.4355 15.754 27.4355 16.0592V27.1005C27.4355 27.6528 26.9878 28.1005 26.4355 28.1005H21.8242C21.2719 28.1005 20.8242 27.6528 20.8242 27.1005V23.3202C20.8242 22.7679 20.3765 22.3202 19.8242 22.3202H18.0459C17.4936 22.3202 17.0459 22.7679 17.0459 23.3202V27.1005C17.0459 27.6528 16.5982 28.1005 16.0459 28.1005H11.4355C10.8833 28.1005 10.4355 27.6528 10.4355 27.1005V16.0592C10.4355 15.754 10.5749 15.4655 10.8141 15.2758L18.3141 9.32596C18.6781 9.03718 19.193 9.03718 19.557 9.32596L27.057 15.2758Z"
      fill={active ? theme.palette.primary[400] : theme.palette.gray[400]}
    />
  </svg>
)

export default HomeIcon
